import React from "react";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Typography from "@mui/material/Typography";
import formatting from "../../../utils/formatHelpers";

export default function BreakTable(props) {
  return (
    <>
      <Table size="small">
        <TableHead>
          <TableRow>
            <TableCell>
              <Typography sx={{ fontWeight: "800" }}>Quantity</Typography>
            </TableCell>
            <TableCell>
              <Typography sx={{ fontWeight: "800" }}>
                Price Per Piece
              </Typography>
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {props.data &&
            props.data.map((tData) => (
              <TableRow key={tData.label}>
                <TableCell>
                  <Typography>{tData.label}</Typography>
                </TableCell>
                <TableCell>
                  <Typography>{formatting["price2"](tData.total)}</Typography>
                </TableCell>
              </TableRow>
            ))}
        </TableBody>
      </Table>
    </>
  );
}
